interface UsuarioMinimo {
  firstName?: string | null
  lastName?: string | null
  email?: string | null
  /**
   * Nombre ya armado. Lo traen los autores cuya cuenta se elimino: al dar de
   * baja se guarda un solo nombre, no nombre y apellido por separado.
   */
  name?: string | null
}

/**
 * El nombre de quien hizo algo, para mostrarlo en pantalla.
 *
 * Cae al correo cuando la cuenta no tiene nombre, y a un guion cuando no hay
 * autor. Ese ultimo caso es normal y no es un error: hay registros anteriores
 * a que se empezara a guardar quien los creaba.
 *
 * Cuando la cuenta se dio de baja, el back manda aparte lo que guardo de ella
 * —en un campo `...Historico`— y se le pasa a esta misma funcion.
 */
export const nombreDeUsuario = (
  usuario?: UsuarioMinimo | null,
  ausente = '—',
): string => {
  if (!usuario) return ausente

  if (usuario.name?.trim()) return usuario.name.trim()

  const nombre = `${usuario.firstName ?? ''} ${usuario.lastName ?? ''}`.trim()
  if (nombre) return nombre

  return usuario.email?.trim() || ausente
}
